import { extractCss } from 'goober'

export function Goober() {
  return <Presenter />
}

function Presenter() {
  return <style id='_goober' innerHTML={extractCss()} />
}
